<template>
  <div>

  </div>
</template>

<script>
  export default {
    mounted() {
      this.$nextTick(() => {
        const tour = this.$shepherd({
          useModalOverlay: false,
          defaultStepOptions: {
            classes: 'shepherd-element shepherd-open shepherd-theme-arrows',
            scrollTo: false,
            cancelIcon: {
              enabled: true,
              label: 'Luk vejledning'
            },
            when: {
              cancel: () => {
                //console.log('directionsTutorialCancel');
                localStorage.setItem('OdenseRundt-TutorialDirections', 'false');
                this.$HelperFunctions.trackSession('directions-tutorial', 'directions-tutorial-closed');
                //app.directionsTutorialActive = false;
              }
            }
          }
        });

        tour.addStep({
          id: 'directions-intro',
          text: 'På Ruteplanlæggeren kan du få vist den anbefalede rute i bil, på cykel og til fods.\
          Rutevejledningen tager højde for aktuelle vejlukninger, ensretninger osv. i hele Odense.<br><div class="tutorial-step-counter">1/4</div>',
          buttons: [
            {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('directions-tutorial', 'routeplanner-intro-next');
              }
            }
          ]
        });

        if(this.$DeviceCheck.isMobile) {
          tour.addStep({
            id: 'directions-points-mobile',
            text: 'Indtast dit start- og slutpunkt her eller hold din finger nede på et punkt på kortet i 2 sekunder.\
            Du kan enten skrive adressen eller navnet på stedet.<br> Klik herefter på <strong>bil, cykel eller fodgænger.</strong><br><div class="tutorial-step-counter">2/4</div>',
            attachTo: {
              element: '#directions-box',
              on: 'bottom'
            },
            buttons: [
              {
                text: 'Tilbage',
                classes: 'shepherd-button-secondary',
                action: tour.back
              }, {
                text: 'Næste',
                classes: 'shepherd-button-primary blue',
                action: () => {
                  tour.next();
                  this.$HelperFunctions.trackSession('directions-tutorial', 'routeplanner-mobile-setAddress-next');
                }
              }
            ]
          });
        }
        else {
          tour.addStep({
            id: 'directions-points-pc',
            text: 'Indtast dit start- og slutpunkt her eller højreklik på kortet.\
            Du kan enten skrive adressen eller navnet på stedet.<br>Klik herefter på <strong>bil, cykel eller fodgænger.</strong><br><div class="tutorial-step-counter">2/4</div>',
            attachTo: {
              element: '#directions-box',
              on: 'bottom'
            },
            buttons: [
              {
                text: 'Tilbage',
                classes: 'shepherd-button-secondary',
                action: tour.back
              }, {
                text: 'Næste',
                classes: 'shepherd-button-primary blue',
                action: () => {
                  tour.next();
                  this.$HelperFunctions.trackSession('directions-tutorial', 'routeplanner-pc-setAddress-next');
                }
              }
            ]
          });
        }

        tour.addStep({
          id: 'directions-points-via',
          text: 'Ønsker du, at din rute skal gå via et bestemt sted, kan du tilføje et viapunkt til den.\
          Viapunktet kan fjernes igen ved at klikke på krydset til venstre for det.<br><div class="tutorial-step-counter">3/4</div>',
          attachTo: {
            element: '#directions-box',
            on: 'bottom'
          },
          buttons: [
            {
              text: 'Tilbage',
              classes: 'shepherd-button-secondary',
              action: tour.back
            }, {
              text: 'Næste',
              classes: 'shepherd-button-primary blue',
              action: () => {
                tour.next();
                this.$HelperFunctions.trackSession('directions-tutorial', 'routeplanner-setVia-next');
              }
            }
          ]
        });

        //Route menu
        if(this.$DeviceCheck.isMobile) {
          tour.addStep({
            id: 'directions-menu-mobile',
            text: 'Vælg hvad du vil se på kortet.<br><br>\
            <img src="https://apps.odenserundt.dk/media/icons/vejarbejde_forvarsling.svg" style="width: 30px; height: 30px;"><strong>Vejarbejde og traffikinformation</strong><br><br>\
            <div class="directions-parking-tutorial-icon light-blue"><span class="marker-text">P</span></div><strong> Parkering</strong><br><br>\
            <span class="material-icons">directions_bus</span><strong> Busruter og stoppesteder</strong><br><br>\
            <img src="https://apps.odenserundt.dk/media/icons/1518681903.svg" style="width: 30px; height: 30px;"> <strong>Ruter i Odense i 2021</strong><br><br>\
            <br><div class="tutorial-step-counter">4/4</div>',
            attachTo: {
              element: '#directions-bottom-bar',
              on: 'top'
            },
            buttons: [
              {
                text: 'Tilbage',
                classes: 'shepherd-button-secondary',
                action: tour.back
              }, {
                text: 'Luk',
                classes: 'shepherd-button-primary blue',
                action: () => {
                  tour.complete();
                  //console.log('directionsTutorialComplete');
                  localStorage.setItem('OdenseRundt-TutorialDirections', 'false');
                  this.$HelperFunctions.trackSession('directions-tutorial', 'directions-tutorial-complete');
                  //app.directionsTutorialActive = false;
                }
              }
            ]
          });
        }
        else {
          tour.addStep({
            id: 'directions-menu-pc',
            text: 'Vælg hvad du vil se på kortet.<br><br>\
            <img src="https://apps.odenserundt.dk/media/icons/vejarbejde_forvarsling.svg" style="width: 30px; height: 30px;"><strong>Vejarbejde og traffikinformation</strong><br><br>\
            <div class="directions-parking-tutorial-icon light-blue"><span class="marker-text">P</span></div><strong> Parkering</strong><br><br>\
            <span class="material-icons">directions_bus</span><strong> Busruter og stoppesteder</strong><br><br>\
            <img src="https://apps.odenserundt.dk/media/icons/1518681903.svg" style="width: 30px; height: 30px;"> <strong>Ruter i Odense i 2021</strong><br>\
            <br><div class="tutorial-step-counter">4/4</div>',
            attachTo: {
              element: '#directions-bottom-bar',
              on: 'bottom'
            },
            buttons: [
              {
                text: 'Tilbage',
                classes: 'shepherd-button-secondary',
                action: tour.back
              }, {
                text: 'Luk',
                classes: 'shepherd-button-primary blue',
                action: () => {
                  tour.complete();
                  localStorage.setItem('OdenseRundt-TutorialDirections', 'false');
                  this.$HelperFunctions.trackSession('directions-tutorial', 'directions-tutorial-complete');
                  //app.directionsTutorialActive = false;
                }
              }
            ]
          });
        }
        tour.start();
        //app.directionsTutorialActive = true;
      });
    }
  };
</script>
